import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnConfig } from './model/ColumnConfig';
import { FilterColumn } from './model/FilterColumn';
import { iListDataResponse } from './model/iListDataResponse';
import { CrudListConfiguration } from './model/CrudListConfiguration';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap/pagination/pagination.module';
import { NgbModule,NgbAlertModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { CrudListComponent } from './crud-list/crud-list.component';
import { FilterFormComponent } from './crud-list/components/filter-form/filter-form.component';
import { ReactiveFormsModule,FormGroup, FormControl,FormBuilder } from '@angular/forms';
import { NgbDateLocalParserFormatter } from '../../providers/NgbDateLocalParserFormatter';

@NgModule({
  imports: [
    CommonModule,
    NgbPaginationModule,
    NgbAlertModule,
    ReactiveFormsModule,
    NgbModule.forRoot()
  ],
  providers: [
    { 
      provide: NgbDateParserFormatter, 
      useFactory: () => { return new NgbDateLocalParserFormatter(); } 
    }
  ],
  declarations: [CrudListComponent, FilterFormComponent],
  exports: [CrudListComponent,FilterFormComponent]

})
export class CrudModule { 

}



// WEBPACK FOOTER //
// I:/Yog/Projects/Web/LetterDev/wwwroot/ManagerApp/wwwroot/src/app/shared/modules/crud/crud.module.ts